export const SHOW_CAROUSEL = 'SHOW_CAROUSEL'
export const HIDE_CAROUSEL = 'HIDE_CAROUSEL'

export function showCarousel(carouselId){
  return {type:SHOW_CAROUSEL, id:carouselId}
}

export function hideCarousel(carouselId){
  return {type:HIDE_CAROUSEL, id:carouselId}
}


// WEBPACK FOOTER //
// ./app/actions/CarouselActions.js